import { ICommonNewbuilding } from '../../types/newbuilding/newbuildings';

export function getNewbuildingInfo(newbuilding: ICommonNewbuilding, position: number, list: string) {
  if (!newbuilding) {
    return {};
  }

  return {
    id: newbuilding.newbuildingId,
    offerType: 'JK',
    position,
    extra: {
      name: newbuilding.name,
      brand: `${newbuilding.builderIds && newbuilding.builderIds.join(',')}/developer_company`,
      category: 'sale/JK',
      list,
    },
  };
}
